export const REFERENCE_LIST_FETCH = 'REFERENCE_LIST_FETCH';
export const REFERENCE_LIST_SUCCESS = 'REFERENCE_LIST_SUCCESS';
export const REFERENCE_LIST_FAILURE = 'REFERENCE_LIST_FAILURE';

export const DELETE_REFERENCE_FETCH = 'DELETE_REFERENCE_FETCH';
export const DELETE_REFERENCE_SUCCESS = 'DELETE_REFERENCE_SUCCESS';
export const DELETE_REFERENCE_FAILURE = 'DELETE_REFERENCE_FAILURE';



// WEBPACK FOOTER //
// ./src/modules/ReferenceList/actionTypes.js